/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Customer_Debt_Delete_SuccessInputs */

const vi_toast_customer_debt_delete_success = /** @type {(inputs: Toast_Customer_Debt_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xóa dòng công nợ`)
};

/**

* @param {Toast_Customer_Debt_Delete_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_customer_debt_delete_success = /** @type {((inputs?: Toast_Customer_Debt_Delete_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Customer_Debt_Delete_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_customer_debt_delete_success(inputs)
});